import { render, staticRenderFns } from "./ReportBrance.vue?vue&type=template&id=29926daa"
import script from "./ReportBrance.vue?vue&type=script&lang=js"
export * from "./ReportBrance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports